__turbopack_context__.v({
  "back": "sub-menu-module__v3ciha__back",
  "list": "sub-menu-module__v3ciha__list",
  "wrapper": "sub-menu-module__v3ciha__wrapper",
});
